export default "__VITE_ASSET__BT6HxpXU__"